import { useState } from "react";
import {
  RiMailSettingsLine,
  RiMessage2Line,
  RiWhatsappLine,
  RiTestTubeLine,
} from "react-icons/ri";

const ChannelConfig = () => {
  const [configs, setConfigs] = useState({
    email: {
      provider: "sendgrid",
      apiKey: "",
      fromEmail: "",
      fromName: "",
    },
    sms: {
      provider: "twilio",
      accountSid: "",
      authToken: "",
      fromNumber: "",
    },
    whatsapp: {
      provider: "meta",
      apiKey: "",
      phoneNumberId: "",
      businessAccountId: "",
    },
  });

  const providers = {
    email: [
      { id: "sendgrid", name: "SendGrid" },
      { id: "ses", name: "Amazon SES" },
      { id: "smtp", name: "Custom SMTP" },
    ],
    sms: [
      { id: "twilio", name: "Twilio" },
      { id: "firebase", name: "Firebase SMS" },
      { id: "nexmo", name: "Nexmo" },
    ],
    whatsapp: [
      { id: "meta", name: "Meta WhatsApp Cloud" },
      { id: "twilio", name: "Twilio WhatsApp" },
    ],
  };

  const handleConfigChange = (channel, field, value) => {
    setConfigs({
      ...configs,
      [channel]: {
        ...configs[channel],
        [field]: value,
      },
    });
  };

  const handleTestConnection = (channel) => {
    // Implement connection test
    console.log(`Testing ${channel} connection...`, configs[channel]);
  };

  const renderEmailConfig = () => (
    <div className="space-y-4">
      <div>
        <label className="label">Provider</label>
        <select
          className="input-field"
          value={configs.email.provider}
          onChange={(e) =>
            handleConfigChange("email", "provider", e.target.value)
          }
        >
          {providers.email.map((provider) => (
            <option key={provider.id} value={provider.id}>
              {provider.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="label">API Key</label>
        <input
          type="password"
          className="input-field"
          value={configs.email.apiKey}
          onChange={(e) =>
            handleConfigChange("email", "apiKey", e.target.value)
          }
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="label">From Email</label>
          <input
            type="email"
            className="input-field"
            value={configs.email.fromEmail}
            onChange={(e) =>
              handleConfigChange("email", "fromEmail", e.target.value)
            }
          />
        </div>
        <div>
          <label className="label">From Name</label>
          <input
            type="text"
            className="input-field"
            value={configs.email.fromName}
            onChange={(e) =>
              handleConfigChange("email", "fromName", e.target.value)
            }
          />
        </div>
      </div>
    </div>
  );

  const renderSMSConfig = () => (
    <div className="space-y-4">
      <div>
        <label className="label">Provider</label>
        <select
          className="input-field"
          value={configs.sms.provider}
          onChange={(e) =>
            handleConfigChange("sms", "provider", e.target.value)
          }
        >
          {providers.sms.map((provider) => (
            <option key={provider.id} value={provider.id}>
              {provider.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="label">Account SID</label>
        <input
          type="password"
          className="input-field"
          value={configs.sms.accountSid}
          onChange={(e) =>
            handleConfigChange("sms", "accountSid", e.target.value)
          }
        />
      </div>
      <div>
        <label className="label">Auth Token</label>
        <input
          type="password"
          className="input-field"
          value={configs.sms.authToken}
          onChange={(e) =>
            handleConfigChange("sms", "authToken", e.target.value)
          }
        />
      </div>
      <div>
        <label className="label">From Number</label>
        <input
          type="text"
          className="input-field"
          value={configs.sms.fromNumber}
          onChange={(e) =>
            handleConfigChange("sms", "fromNumber", e.target.value)
          }
        />
      </div>
    </div>
  );

  const renderWhatsAppConfig = () => (
    <div className="space-y-4">
      <div>
        <label className="label">Provider</label>
        <select
          className="input-field"
          value={configs.whatsapp.provider}
          onChange={(e) =>
            handleConfigChange("whatsapp", "provider", e.target.value)
          }
        >
          {providers.whatsapp.map((provider) => (
            <option key={provider.id} value={provider.id}>
              {provider.name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="label">API Key</label>
        <input
          type="password"
          className="input-field"
          value={configs.whatsapp.apiKey}
          onChange={(e) =>
            handleConfigChange("whatsapp", "apiKey", e.target.value)
          }
        />
      </div>
      <div>
        <label className="label">Phone Number ID</label>
        <input
          type="text"
          className="input-field"
          value={configs.whatsapp.phoneNumberId}
          onChange={(e) =>
            handleConfigChange("whatsapp", "phoneNumberId", e.target.value)
          }
        />
      </div>
      <div>
        <label className="label">Business Account ID</label>
        <input
          type="text"
          className="input-field"
          value={configs.whatsapp.businessAccountId}
          onChange={(e) =>
            handleConfigChange("whatsapp", "businessAccountId", e.target.value)
          }
        />
      </div>
    </div>
  );

  return (
    <div className="space-y-8">
      {/* Email Configuration */}
      <div className="card">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <div className="p-3 rounded-lg bg-primary-50">
              <RiMailSettingsLine className="w-6 h-6 text-primary-500" />
            </div>
            <h3 className="text-lg font-semibold text-secondary-900">
              Email Configuration
            </h3>
          </div>
          <button
            className="btn btn-secondary flex items-center"
            onClick={() => handleTestConnection("email")}
          >
            <RiTestTubeLine className="w-5 h-5 mr-2" />
            Test Connection
          </button>
        </div>
        {renderEmailConfig()}
      </div>

      {/* SMS Configuration */}
      <div className="card">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <div className="p-3 rounded-lg bg-success-50">
              <RiMessage2Line className="w-6 h-6 text-success-500" />
            </div>
            <h3 className="text-lg font-semibold text-secondary-900">
              SMS Configuration
            </h3>
          </div>
          <button
            className="btn btn-secondary flex items-center"
            onClick={() => handleTestConnection("sms")}
          >
            <RiTestTubeLine className="w-5 h-5 mr-2" />
            Test Connection
          </button>
        </div>
        {renderSMSConfig()}
      </div>

      {/* WhatsApp Configuration */}
      <div className="card">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <div className="p-3 rounded-lg bg-warning-50">
              <RiWhatsappLine className="w-6 h-6 text-warning-500" />
            </div>
            <h3 className="text-lg font-semibold text-secondary-900">
              WhatsApp Configuration
            </h3>
          </div>
          <button
            className="btn btn-secondary flex items-center"
            onClick={() => handleTestConnection("whatsapp")}
          >
            <RiTestTubeLine className="w-5 h-5 mr-2" />
            Test Connection
          </button>
        </div>
        {renderWhatsAppConfig()}
      </div>
    </div>
  );
};

export default ChannelConfig;
